import Index from './Index.vue';

export default {
  path: '',
  name: 'home',
  component: Index,
};
